import script from "./faq-component.vue?vue&type=script&setup=true&lang=js"
export * from "./faq-component.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__